import { Component } from "react"

/* Components */
import { Layout, Video } from "../../components"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Helpers */
import { withRouter } from "../../helpers"

/* REST API */
import { get } from "../../api/Table"

/* SOCKET.IO */
import { io } from "socket.io-client"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"
import { CheckIcon, CloseIcon } from "../../components/Icons"

/* Widgets */
import { Games } from "../../widgets/VipGame"
import { RoundModal } from "../../widgets/Round"
import { Panel as TablePanel, Menu as TableMenu } from "../../widgets/Table"







/* Page VipGame */
class VipGame extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            connection: "loading",
            data: null,
        }

        this.socket = null
        this.timing = null
    }


    componentDidMount = () => {

        /* Start Load Data About Table */
        this.load()

        /* Start Listen Socket Events */
        this.socketEvents()

    }


    componentWillUnmount = () => {

        /* Remove Timing */
        if (this.timing) {
            clearTimeout(this.timing)
            this.timing = null
        }

        /* Remove Socket */
        if (this.socket) {
            this.socket.off("connect")
            this.socket.off("disconnect")
            this.socket.disconnect()
            this.socket.close()
            this.socket = null
        }

    }


    /* Load Table Data */
    load = (reload = false) => {

        /* Fields */
        const { uid } = this.props.params

        /* Check Data */
        if (uid) {

            /* Refresh the page if necessary */
            if (reload) {
                this.setState({ status: "loading" })
            }

            /* START REST API */
            get({ uid }).then((response) => {
                if (response.status === 200) {
                    const data = response.data
                    this.setState({ status: "ok", data })
                    this.connect(data)
                }
                else if (response.status === 401 || response.status === 403) {
                    this.setState({ status: "permission", data: null })
                }
                else if (response.status === 498) {
                    this.setState({ status: "key", data: null })
                }
                else {
                    this.setState({ status: "error", data: null })
                }
            }).catch(() => {
                this.setState({ status: "network", data: null })
            })
        }
        else {
            this.setState({ status: "error", data: null })
        }

    }

    /* Connect Socket */
    connect = (data) => {
        try {
            this.socket = io(data.backURL, { auth: { token: `${data.adminToken}`, type: "admin" } })
        }
        catch {
            this.setState({ connection: "disconnected" })
        }
    }

    /* Socket Events */
    socketEvents = () => {

        if (this.socket) {

            if (this.timing) {
                clearTimeout(this.timing)
                this.timing = null
            }

            if (this.socket.connected) {
                this.setState({ connection: "connected" })
            }

            this.socket.on("connect", () => {
                this.setState({ connection: "connected" })
            })

            this.socket.on("connect_error", () => {
                this.setState({ connection: "disconnected" })
            })

            this.socket.on("disconnect", () => {
                this.setState({ connection: "disconnected" })
            })

        }
        else {
            this.timing = setTimeout(() => {
                clearTimeout(this.timing)
                this.timing = null
                this.socketEvents()
            }, 2000)
        }

    }


    /* Open Panel Action — every panel of the table lives in one shared modal, opened by a ref */
    openPanel = (key) => {
        if (this._panel) {
            this._panel.open(key)
        }
    }


    /* Draw Connection State */
    _connection = () => {

        const { connection } = this.state

        if (connection === "connected") {
            return (
                <div className="vippoker--game-header-connection-status connected">
                    <CheckIcon size={12} />
                    {t("game.connectionOk")}
                </div>
            )
        }

        if (connection === "disconnected") {
            return (
                <div className="vippoker--game-header-connection-status disconnected">
                    <CloseIcon size={12} />
                    {t("game.connectionFail")}
                </div>
            )
        }

        return (
            <div className="vippoker--game-header-connection-status">
                <LoadingOutlined />
                {t("game.connecting")}
            </div>
        )
    }


    /* Open Game Inner Action — the round card is a modal of its own, named by the round and the table */
    openGame = (id) => {

        /* Check Modal */
        if (!this._round) {
            return
        }

        this._round.open({ round: id, table: this.props.params.uid })
    }

    /* Close With Update — the round may have been closed by hand, so the list reads itself again */
    closeWithUpdate = () => {

        /* Check Games */
        if (this._games && this._games.reloadGames) {
            this._games.reloadGames()
        }
    }


    render = () => {

        /* Fields */
        const { status, data } = this.state
        const { postfix } = this.props

        /* Layout */
        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        return (
            <div className="page">

                {/* Draw Header */}
                <div className="vippoker--game-header">
                    <h1>{data.name}</h1>
                    <div className="vippoker--game-header-connection">
                        <p>{data.slug}</p>
                        {this._connection()}
                    </div>
                </div>

                {/* Draw Menu */}
                <TableMenu open={(key) => this.openPanel(key)} video={data.recordURL} />

                {/* Draw Games */}
                <Games
                    ref={(ref) => this._games = ref}
                    postfix={postfix}
                    uid={data.uid}
                    openGame={(id, number) => this.openGame(id, number)}
                />

                {/* Draw Modal */}
                {/* Draw Round */}
                <RoundModal ref={(ref) => this._round = ref} socket={this.socket} close={() => this.closeWithUpdate()} />

                {/* Draw Panels */}
                <TablePanel ref={(ref) => this._panel = ref} uid={data.uid} socket={this.socket} />

                <Video room={data.room} serviceURL={data.serviceURL} />

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
    admin: state.admin,
})

export default connect(mapStateToProps)(withRouter(VipGame))